module.exports = __webpack_public_path__ + "static/ClickUp-44958e8ba8ceeab4485256731ac9888a.png";